import React from 'react';
import { Section } from './ui/Section';
import { ShieldCheck } from 'lucide-react';
export const GuaranteeSection = () => {
  return <Section data-id="element-237">
      <div className="max-w-3xl mx-auto text-center" data-id="element-238">
        <div className="flex justify-center mb-8" data-id="element-239">
          <div className="w-24 h-24 bg-accent-blue/10 rounded-full flex items-center justify-center border border-accent-blue/30" data-id="element-240">
            <ShieldCheck className="w-12 h-12 text-accent-blue" data-id="element-241" />
          </div>
        </div>

        <h2 className="text-3xl md:text-4xl font-bold mb-4 text-white" data-id="element-242">
          Tu inversión está protegida
        </h2>

        <h3 className="text-2xl font-bold text-cta mb-8" data-id="element-243">GARANTÍA DE 7 DÍAS</h3>

        <div className="space-y-6 text-lg text-gray-300 leading-relaxed bg-night-800 p-8 md:p-12 rounded-3xl border border-night-700" data-id="element-244">
          <p data-id="element-245">Probá el sistema durante 7 días.</p>
          <p data-id="element-246">Aplicalo. Usá las técnicas. Hacé la descarga.</p>
          <p className="text-white font-medium" data-id="element-247">
            Si después de 7 días de aplicarlo honestamente sentís que no te
            sirvió para nada, te devolvemos el dinero.
          </p>
          <p data-id="element-248">Sin preguntas. Sin vueltas.</p>

          <div className="h-px w-full bg-night-700 my-8" data-id="element-249" />

          <h4 className="text-xl font-bold text-white mb-4" data-id="element-250">
            ¿Por qué 7 días y no 30?
          </h4>
          <p data-id="element-251">Porque este sistema funciona rápido.</p>
          <p data-id="element-252">
            La mayoría de las personas nota diferencia en las primeras 3 noches.
          </p>
          <p data-id="element-253">7 días son más que suficientes para saber si funciona para vos.</p>
          <p className="text-xl font-medium text-white mt-6" data-id="element-254">
            Si no funciona, te devolvemos todo.
            <br data-id="element-255" />
            Si funciona, cambiaste tus noches para siempre.
          </p>
        </div>
      </div>
    </Section>;
};